import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";

class ErrorDialog extends Component {
  render() {
    return (
      <Dialog
        open={true}
        onClose={() => this.props.history.push(this.props.url)}
      >
        <DialogTitle>{this.props.message}</DialogTitle>
        <DialogActions>
          <Button onClick={() => this.props.history.push(this.props.url)}>
            Try Again
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withRouter(ErrorDialog);
